// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {t_use_cp} from './use_cp';
import Icon_mobile from '../../img/hola2023/icons/24/mobile_button.svg';
import Icon_monitor from '../../img/hola2023/icons/24/monitor.svg';
import Icon_laptop from '../../img/hola2023/icons/24/laptop.svg';
import Icon_rainbow from '../../img/hola2023/icons/24/rainbow.svg';
import Icon_map_pin from '../../img/hola2023/icons/24/map_pin.svg';
import Icon_arrow from '../../img/hola2023/icons/24/arrow_up_right.svg';
import {Button} from '../../../../shared/button';
import {Modal} from '../../../../shared/ui/modal';
import styles from './cp_apps.module.less';

const products = [
    {
        id: 'mobile',
        title: 'Mobile apps',
        icon: <Icon_mobile/>,
        link: '/products/mobile',
    },
    {
        id: 'desktop',
        title: 'Desktop apps',
        icon: <Icon_laptop/>,
        link: '/products/desktop',
    },
    {
        id: 'tv',
        title: 'TV apps',
        icon: <Icon_monitor/>,
        link: '/products/tv',
    },
    {
        id: 'console',
        title: 'Gaming devices and other apps',
        icon: <Icon_rainbow/>,
        link: '/products/console',
    },
    {
        id: 'smart_dns',
        title: 'Smart DNS',
        icon: <Icon_map_pin/>,
        link: '/smart_dns',
    },
];

type t_cp_apps_props = Partial<Pick<t_use_cp, 'apps' | 'back_btn'>>;

export const CP_apps = (props: t_cp_apps_props)=>{
    const {apps, back_btn} = props;
    const {theme} = useContext(Settings_context);
    const {logout, status} = apps;
    const [dev, set_dev] = useState(null);
    const on_logout = (id, name)=>()=>{
      set_dev({id, name});
    };
    useEffect(()=>{
        if (dev && status=='success')
            set_dev(null);
    }, [dev, status]);
    return <div className={cn(styles.content, styles.apps)}>
      <h1 className={styles.title}>{back_btn}Hola products</h1>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Connect to Hola on your favorite
          devices</h2>
        <div className={styles.products}>
          {products.map(({id, link, title, icon})=>{
              const cls = cn(styles.line, styles.product);
              return <Link key={id} to={link} className={cls}>
                <p className={styles.line_text}>{icon} {title}</p>
                <div className={styles.line_control}><Icon_arrow/></div>
              </Link>;
          })}
        </div>
      </section>
      <h1 className={styles.title}>Devices</h1>
      {/* XXX dmitriyr: add linked devices list */}
      {/* <section className={styles.section}>
        <h2 className={styles.section_title}>Linked devices</h2>
      </section> */}
      <section className={styles.section}>
        <h2 className={styles.section_title}>Log out everywhere</h2>
        <p className={cn(theme.p3, styles.log_out_text)}>
          This logs you out of Hola everywhere you're logged in, including
          the mobile, tablet, web and desktop apps.
        </p>
        <Button color="white" size="md" inline
          on_click={on_logout('all', 'everywhere')}
          caption="Log out everywhere" cls={styles.logout_all}/>
      </section>
      <Modal is_open={!!dev}
        on_close={()=>set_dev(null)} width={489} cls={styles.modal}>
        <div className={styles.logout}>
          <p className={cn(theme.bold, styles.p_title)}>
            Are you sure you want to log out {dev?.name}?
          </p>
          {dev?.id=='all' && <p className={cn(theme.p2, styles.p_text)}>
            This will log you out of all sessions and all devices.
          </p>}
          <div className={styles.buttons}>
            <Button caption="Stay connected" color="white"
              size="md" on_click={()=>{ set_dev(null); }}/>
            <Button caption="Log me out" color="black2023"
              size="md" on_click={()=>{ logout(dev?.id); }}/>
          </div>
        </div>
      </Modal>
    </div>;
};
